import React from 'react';
import { Button } from '../../../../';
import { Form, Alert, Tooltip, Row, Col } from 'antd';
import { QuestionCircleOutlined, LoadingOutlined } from '@ant-design/icons';

export const TestConnectionButton = ({
    onTest,
    testing = false,
    tested = false,
    label = 'Test connection',
    tooltip = 'Test the connection to verify credentials.',
    required = false,
    error,
}) => {
    return (
        <Form.Item
            label={
                <span>
                    {label}{' '}
                    <Tooltip title={tooltip}>
                        <QuestionCircleOutlined />
                    </Tooltip>
                </span>
            }
            validateStatus={error ? 'error' : ''}
            help={error}
            required={required}
        >
            <Row gutter={8}>
                <Col span={12}>
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={onTest}
                        loading={testing}
                        icon={testing ? <LoadingOutlined /> : null}
                    >
                        {testing ? 'Testing...' : label}
                    </Button>
                </Col>
                <Col span={12}>
                    {tested && (
                        <Alert title="Connection validated" type="success" showIcon style={{ padding: '4px 8px' }} />
                    )}
                </Col>
            </Row>
        </Form.Item>
    );
};
